import { create } from 'zustand';
import i18n from 'i18n';
import { RegisterApi, RegisterFinalRequest, RestApiError, StatusCodeEnum } from '@shared/api';
import type { BaseReturn } from '@shared/types';

interface UseRegisterFinalStore {
  loading: boolean;
  data: any;
  error?: string | null;
  registerFinal: (request: RegisterFinalRequest) => Promise<BaseReturn<any>>;
  clear: () => void;
}

export const useRegisterFinalStore = create<UseRegisterFinalStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  registerFinal: async (request) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await RegisterApi.registerFinal(request);
      set({ loading: false, data: result ?? null });
      return { loading: false, data: result ?? null };
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Something went wrong, try again';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_BAD_REQUEST:
          if (Array.isArray(restError?.data)) errorMessage = restError?.data?.join('\n');
          break;
      }

      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
